import { getVertexId } from '../../core/util';
import type { CoreTypes } from '../../core';
import type { Types as SduiTypes } from '../types';

export default (
  group:   CoreTypes.Mixed.Group,
  options: SduiTypes.options
): SduiTypes.classes => {
  return {
    id: getVertexId(group, options),
  };
};
